export enum KioskConfigurationGroupEnum {
  checkout = 'Checkout',
  security = 'Security',
  heroMediaFile = 'Hero Media File'
}
